intra_module.factory('Stats', function($resource, modules_url) {
    const url     = `${modules_url}/:session_id`;
    const params  =
        {session_id: '@session_id'};
    const actions = {
        getModuleViewsStats: {
            url:    `${url}/all_file_views`,
            method: 'GET'
        },

        getStatsViews: {
            url:    `${url}/activities/:activity_id/fileview_stats`,
            method: 'GET',
            params: {
                activity_id: '@activity_id'
            }
        },

        getViewStatus: {
            url:     `${url}/students/:student_id/student_file_view`,
            method:  'GET',
            cache:   false,
            isArray: true,
            params: {
                student_id: '@student_id'
            }
        }
    };

    return $resource(url, params, actions);
});
